import React from 'react';
import { Box } from '@wix/design-system';
import { ToggleCollapsibleButton } from '../../../../Collapse';
import { Z_INDEX } from '../../../consts';
import { FeatureSectionContext } from '../FeatureSection';
import s from '../FeatureSection.scss';
export const FeatureSectionHeader = ({ children, labels, dataHook, onToggle, }) => {
    const { isOpen, toggleCollapse, onMouseEnter, onMouseLeave, isHovering } = React.useContext(FeatureSectionContext);
    const handleClick = () => {
        onToggle?.(isOpen ? 'close' : 'open');
        toggleCollapse();
    };
    return (React.createElement("div", { onClick: handleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, className: s.stickySection, style: { zIndex: Z_INDEX.SECTION_HEADER } },
        React.createElement(Box, { width: "100%", verticalAlign: "middle", align: "space-between", className: s.sectionHeader, dataHook: dataHook },
            children,
            React.createElement(ToggleCollapsibleButton, { labels: labels, isOpen: isOpen, visible: isHovering, size: "small", classNames: { icon: s.standard } }))));
};
//# sourceMappingURL=FeatureSectionHeader.js.map